import { Alert, Dialog, LinearProgress } from "@mui/material";
import type { FC } from "react";
import { useLexicalContext } from "../../lexical-context";
import { usePollButtonCommands } from "../toolbar/poll/hooks/use-poll-button-commands";
import { usePollDataLoader } from "./hooks/use-poll-default-values";
import { PollForm } from "./poll-form/poll-form";

export const PollPlugin: FC = () => {
  usePollButtonCommands();

  const {
    editorModal: { open, handleClose, data },
  } = useLexicalContext();

  const { data: defaultValues, loading, error: defaultValuesError } = usePollDataLoader(data);

  if (data?.type !== "poll") return null;

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      {defaultValuesError && <Alert severity="error">{defaultValuesError.message}</Alert>}
      {loading && <LinearProgress />}
      {defaultValues && (
        <PollForm
          action={data.data}
          defaultValues={defaultValues.data}
          handleClose={handleClose}
          presets={defaultValues.presets}
        />
      )}
    </Dialog>
  );
};
